module.exports = __webpack_public_path__ + "static/media/logoicon.8c1c2f27.png";